import { addBusinessDays, startOfDay } from 'date-fns'

const MINIMUM_BUSINESS_DAYS_OFFSET = 3
export const getEarliestBusinessDate = () => addBusinessDays(startOfDay(Date.now()), MINIMUM_BUSINESS_DAYS_OFFSET)
